import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgrupacionPolizasSalud } from '../../../comun/model/recomendador.model';
import { CaCheckboxComponent } from '@global-front-components/ui/checkbox';

@Component({
	selector: 'app-impresion-colectivas',
	standalone: true,
	imports: [
        CommonModule,
        CaCheckboxComponent
    ],
	templateUrl: './impresion-colectivas.component.html',
	styleUrls: ['./impresion-colectivas.component.scss']
})
export class ImpresionColectivasComponent {
    @Input() agrupacionesPropuestas: AgrupacionPolizasSalud[] = [];
    @Output() colectivasImprimirChange = new EventEmitter<string[]>();

    private seleccionados = new Set<string>();

    changeImpresionColectiva(event: { source: any; checked: boolean }, codColectiva: string) {
        if (event.checked) {
            this.seleccionados.add(codColectiva);
        } else {
            this.seleccionados.delete(codColectiva);
        }
        this.colectivasImprimirChange.emit(Array.from(this.seleccionados));
    }
}
